import { render, staticRenderFns } from "./materialTypeComponent.vue?vue&type=template&id=082aa893&scoped=true&"
import script from "./materialTypeComponent.vue?vue&type=script&lang=js&"
export * from "./materialTypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./materialTypeComponent.vue?vue&type=style&index=0&id=082aa893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082aa893",
  null
  
)

export default component.exports